import { useId } from 'react';
import {
  DEVICE_NICKNAME_MAX_LENGTH,
  DEVICE_NICKNAME_PRESETS,
} from '@platform/billing';

interface DeviceNicknameFieldProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  hint?: string;
  autoFocus?: boolean;
}

/**
 * 기기 별명 입력 + 추천 칩. 칩은 값을 채울 뿐 고정 분류가 아니다 — 누른 뒤 이어서 고칠 수 있다.
 * 길이 제한은 서버와 같은 값을 쓴다(DEVICE_NICKNAME_MAX_LENGTH).
 */
export function DeviceNicknameField({
  value,
  onChange,
  label = 'PC 이름',
  hint,
  autoFocus = false,
}: DeviceNicknameFieldProps) {
  const id = useId();
  return (
    <div>
      <label
        htmlFor={id}
        className="mb-1.5 block text-xs font-semibold text-adobe-dark dark:text-neutral-200"
      >
        {label}
      </label>
      <input
        id={id}
        type="text"
        value={value}
        maxLength={DEVICE_NICKNAME_MAX_LENGTH}
        autoFocus={autoFocus}
        placeholder="예: 집, 직장, 노트북"
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-lg border border-black/[0.12] bg-white px-3 py-2 text-sm text-adobe-dark outline-none transition-colors focus:border-brand-700 dark:border-white/15 dark:bg-transparent dark:text-neutral-100"
      />
      <div className="mt-2 flex flex-wrap gap-1.5">
        {DEVICE_NICKNAME_PRESETS.map((preset) => (
          <button
            key={preset}
            type="button"
            onClick={() => onChange(preset)}
            aria-pressed={value.trim() === preset}
            className={[
              'rounded-full border px-2.5 py-1 text-xs font-semibold transition-colors',
              value.trim() === preset
                ? 'border-brand-700 bg-brand-700 text-white'
                : 'border-black/[0.12] text-adobe-dark hover:bg-neutral-50 dark:border-white/15 dark:text-neutral-200 dark:hover:bg-white/5',
            ].join(' ')}
          >
            {preset}
          </button>
        ))}
      </div>
      {hint && <p className="mt-1.5 text-xs text-adobe-muted">{hint}</p>}
    </div>
  );
}
